import { createRouter, createWebHistory } from 'vue-router'
import { mentalHealthRoutes } from "@/views/module-mental-health/router"
const routes = [
  ...mentalHealthRoutes,
  {
    path: '/index',
    component:()=>import("@/views/index.vue"),
    meta:{
      auth:true
    },
  },
  {
    path: '/login',
    component:()=>import("@/views/login.vue"),
    meta:{
      auth:false
    },
  },
  {
    path: '/register',
    component:()=>import("@/views/register.vue"),
    meta:{
      auth:false
    },
  },
  {
    path: '/agreement',
    component:()=>import("@/views/agreement.vue"),
    meta:{
      auth:false
    },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
